import { displayPartnerCustomerList } from '../../../../widgets/partner-customer-widget';
import { getSelectedItem } from './select-items';
import { searchAvailList } from './search-list';

import GetPartners from '../../../../../routes/get-partners';

/**
 * Function that gets a list of partner data and displays it.
 */
const GetPartnerData = async () => {
  const { body } = await GetPartners();

  const mapList = Object.values(body).map((r: any) => ({
    id: r.partnerID,
    name: r.partnerName
  }));
  
  const partnerList = document.querySelectorAll<HTMLElement>('[data-id]');
  const accessList = Array.from(partnerList).map(e => ({
    partnerId: e.getAttribute('data-id')
  }));

  const avalPartners = mapList.filter(item => accessList.every(item2 => item2.partnerId != item.id));
  const avaListContainer = document.querySelector('.aafp_list-result-container') as HTMLElement;
  const searchBar = document.querySelector('#aafp_customer-input') as HTMLInputElement;
  const con = document.querySelector('.aafp_partner-container') as HTMLElement;
  if ( avaListContainer ) {
    avaListContainer.innerText = '';
    displayPartnerCustomerList(avalPartners, avaListContainer);
    getSelectedItem(avaListContainer, con);  
    searchAvailList(searchBar, avaListContainer); 
  }

}

export default GetPartnerData;